var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"knows-top"},[_c('img',{attrs:{"height":"100%","width":"100%","src":require("../assets/myImage/big.png"),"alt":""}}),_c('ConsultantForm',{staticClass:"myForm"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }